import { Casier } from "../models/Casier";
import { Location } from "../models/Location";
import { Niveau } from "../models/Niveau";
import { Pavillon } from "../models/Pavillon";
import { Periode } from "../models/Periode";
import { Pilotage } from "../models/Pilotage";
import { TypeClientele } from "../models/TypeClientele";
import { VariableEnvironnementDefinition } from "../models/VariableEnvironnementDefinition";
import { VariableEnvironnementValue } from "../models/VariableEnvironnementValue";
import { NomEtapes } from "./trainProgression";

export interface IUtilisateurState {
  locations: Location[];
  nouvelleLocation: Location | null;
  typeClientele: TypeClientele | null;
  periode: Periode | null;
  pavillon: Pavillon | null;
  niveau: Niveau | null;
  casier: Casier | null;
  montant: number | null;
  courriel: string | null;
  acceptationModalites: boolean | null;
  dateDebutCreationLocation: Date | null;
  isDelaiLocationDepasse: boolean | null;
}

export interface ITrainProgressionState {
  precedentActive: boolean;
  suivantActive: boolean;
  suivantCache: boolean;
  etapeCourante: NomEtapes;
  surAnnuler: boolean;
}

export interface IMinuteurState {
  verrouDateFin: number | null;
  tempsRestantEnSeconde: number | null;
  tempsAlloueEchu: boolean;
  identifiantMinuteur: number | null;
}

export interface IApplicatifState {
  variableEnvCleCourrielContact: string;
  variableEnvCleOptionCasierDisponible: string;
  variableEnvCleDelaiVerrou: string;
  pilotageCleConditionsUtilisation: string;
  pilotageCleModalitesLocation: string;
  pilotageCleSiteSIAide: string;
  messageErreurParDefaut: string;
  messageErreur: string;
}

export interface ICDSState {
  typesClientele: TypeClientele[];
  periodes: Periode[];
  pavillons: Pavillon[];
  niveaux: Niveau[];
  definitionsVariablesEnv: VariableEnvironnementDefinition[];
  valeursVariablesEnv: VariableEnvironnementValue[];
  parametresPilotage: Pilotage[];
  locations: Location[];
  casiers: Casier[];
}

export interface IRacineState {
  utilisateur: IUtilisateurState;
  cds: ICDSState;
  trainProgression: ITrainProgressionState;
  minuteur: IMinuteurState;
  applicatif: IApplicatifState;
}

export const stateDeBase = (): ICDSState => {
  return {
    definitionsVariablesEnv: [],
    valeursVariablesEnv: [],
    typesClientele: [],
    periodes: [],
    pavillons: [],
    niveaux: [],
    casiers: [],
    parametresPilotage: [],
    locations: [],
  };
};
